import { Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Logo from "./Logo";

export default function Cabecera() {
  const desktop = useMediaQuery("(min-width: 1000px)");

  return (
    <Box
      sx={{
        width: "100%",
        height: "130px",
        bgcolor: "#B71234",
        borderRadius: 2,
        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          marginY: "14px",
          ...(desktop && {
            justifyContent: "start",
            marginY: "40px",
            marginLeft: "20px",
          }),
        }}
      >
        <Logo with={desktop ? 50 : 30} height={desktop ? 50 : 30} />
      </Box>
    </Box>
  );
}
